<template>
  <div class="app-download-page">
    <client-only>
      <div class="container">
        <InnerTitle class="mb-5" center>
          <template #title>
            Скачайте мобильное приложение
          </template>
          <template #subtitle>
            Откройте на телефоне камеру и отсканируйте qr-код или перейдите по ссылкам ниже
          </template>
        </InnerTitle>

        <div class="app-items-container">
          <div class="app-download-page_app-item">
            <mobile-app-qr-code platform="apple" class="app-download-page_app-qr" />
            <MobileApp platform="apple" always-sow-links class="app-download-page_app-link" />
          </div>
          <div class="app-download-page_app-item">
            <mobile-app-qr-code platform="gplay" class="app-download-page_app-qr" />
            <MobileApp platform="gplay" always-sow-links class="app-download-page_app-link" />
          </div>
          <div class="app-download-page_app-item">
            <mobile-app-qr-code platform="rustore" class="app-download-page_app-qr" />
            <MobileApp platform="rustore" always-sow-links class="app-download-page_app-link" />
          </div>
        </div>
      </div>
    </client-only>
  </div>
</template>

<script>
import MobileApp from '~/components/UI/MobileApp.vue'
import MobileAppQrCode from '~/components/UI/MobileAppQrCode.vue'
import InnerTitle from '~/components/UI/InnerTitle.vue'

export default {
  components: { InnerTitle, MobileAppQrCode, MobileApp },
}
</script>

<style lang="less" scoped>
.store-img {
  width: 40%;
  max-width: 300px;
}
.app-download-page {
  margin-bottom: 70px;

  &_title {
    margin-bottom: 50px;
    text-align: center;
  }

  &_app-item {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    margin-left: 40px;
    margin-right: 40px;
  }

  &_app-link {
    margin-bottom: 30px;
    width: 90%;
    max-width: 170px;
  }

  &_app-qr {
    margin-bottom: 30px;
  }

  ::v-deep {
    .mobile-apps {
      width: 100%;
      justify-content: center;

      &_item {
        img {
          height: auto;
          width: 100%
        }
      }
    }

  }
  @media (min-width: 768px) {
    min-height: calc(100vh - 590px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.app-items-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
</style>
